module.exports = __webpack_public_path__ + "static/img/Jason-Horne-Francis.6add7d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason-Horne-Francis.jpg
// module id = XBLO
// module chunks = 0